import styled from 'styled-components';

import HeroHeading from 'components/hero-heading';

export const StyledHeroHeading = styled(HeroHeading)`
  color: ${p => p.theme.token('text-reversed')};
`;
